import React, { useRef, useEffect } from "react";
import { IconCross } from "../../assets/icons";

const VideoPlayerModal = ({ isOpen, onClose, videoUrl, title = "Demo Video" }) => {
  const videoRef = useRef(null);

  useEffect(() => {
    if (isOpen && videoRef.current && videoUrl) {
      videoRef.current.load();
    }
  }, [isOpen, videoUrl]);

  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === "Escape" && isOpen) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener("keydown", handleEscape);
      document.body.style.overflow = "hidden";
    }

    return () => {
      document.removeEventListener("keydown", handleEscape);
      document.body.style.overflow = "unset";
    };
  }, [isOpen, onClose]);

  const handleClose = () => {
    if (videoRef.current) {
      videoRef.current.pause();
      videoRef.current.currentTime = 0;
    }
    onClose();
  };

  if (!isOpen || !videoUrl) return null;

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="flex items-center justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
        <div
          className="fixed inset-0 bg-gray-900 bg-opacity-75 transition-opacity"
          onClick={handleClose}
        />
        <div className="inline-block align-bottom bg-white rounded-2xl text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-5xl sm:w-full">
          <div className="bg-gradient-to-r from-red-600 to-red-700 px-6 py-4">
            <div className="flex items-center justify-between">
              <h3 className="text-xl font-bold text-white">{title}</h3>
              <button
                onClick={handleClose}
                className="text-white hover:text-gray-200 transition-colors duration-200"
              >
                <IconCross />
              </button>
            </div>
          </div>
          <div className="">
            <div className="relative w-full" style={{ paddingBottom: "56.25%" }}>
              <video
                ref={videoRef}
                controls
                className="absolute top-0 left-0 w-full h-full rounded-lg"
                style={{ objectFit: "contain" }}
              >
                <source src={videoUrl} type="video/mp4" />
                <source src={videoUrl} type="video/quicktime" />
                <source src={videoUrl} type="video/webm" />
                Your browser does not support the video tag.
              </video>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VideoPlayerModal;

